/** @format */

import React, { Component } from "react";
import SignInSignUp from "../SignInSignUp/index";
import HeaderSearch from "@/components/HeaderSearch";
import { withRouter } from "react-router-dom";

import { Affix, Avatar, Popover } from "antd";
import { connect } from "react-redux";
import Nav from "./nav";
import "./header.less";
import SlideMenu from "./SlideMenu";

import { getGreetingText } from "../../utils/greetingText";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top: 0,
    };
  }

  handleSearch(keyword) {
    this.props.history.replace(`/search-result/${keyword}`);
  }

  render() {
    const isLogin = this.props.userId !== "" && this.props.username !== "";

    return (
      <>
        {/* 导航栏 */}
        <Affix offsetTop={this.state.top}>
          <div className="page-header">
            <div className="container">
              {/* logo */}
              <a href="/" className="logo">
                <img
                  src="https://librec.oss-cn-hangzhou.aliyuncs.com/Snipaste_2021-01-17_16-02-14.png"
                  alt="LibRec"
                  className="logo-img"
                />
              </a>
              {/* 竖向分割线 */}
              <div
                style={{
                  width: "1px",
                  height: "20px",
                  background: "#00000033",
                }}
              />

              {/* Greetings */}
              <div className="greeting-text">{getGreetingText()}</div>

              {/* 导航 */}
              <nav className="main-nav">
                {/* 导航栏 */}
                <Nav />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <HeaderSearch
                    styleObj={{
                      position: "relative",
                      top: "4px",
                      marginRight: "30px",
                    }}
                    placeholder="Search Papers"
                    onSearch={(value) => {
                      console.log("input", value); // eslint-disable-line
                      this.handleSearch(value);
                    }}
                    onPressEnter={(value) => {
                      console.log("enter", value); // eslint-disable-line
                    }}
                  />
                  {/* <Search placeholder="搜索更新啦" onSearch={value => console.log(value)} style={{ width: 200 }} /> */}

                  {isLogin ? (
                    <Popover
                      placement="bottomRight"
                      content={<SlideMenu userId={this.props.userId} />}
                      trigger="click"
                    >
                      <Avatar
                        icon="user"
                        src={this.props.userImage}
                        style={{ cursor: "pointer" }}
                      />
                    </Popover>
                  ) : (
                    <>
                      {/* 登录/注册 & Modal */}
                      <SignInSignUp isLogin={isLogin} />
                    </>
                  )}
                </div>
              </nav>
            </div>
          </div>
        </Affix>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  count: state.pageHeaderReducer.notificationCount,
  username: state.userReducer.username,
  userImage: state.userReducer.userImage,
  userId: state.userReducer.userId,
});

Header = connect(mapStateToProps)(Header);

export default withRouter(Header);
